import React, { useState, useEffect, useRef } from 'react';
import { Home, Briefcase, MessageCircle, Star, CreditCard, Bell, Heart, Search, Menu, X, ChevronDown, Settings, LogOut, User, HelpCircle, Gem, BookOpen } from 'lucide-react';
import styles from './ModernNavBarPureCSS.module.css';
import { jwtDecode } from 'jwt-decode';
import imageLogo from "../../assets/images/LogoBuildStart03.png";
import { useNavigate } from 'react-router-dom'; 

import { SOCIAL_FRONTEND_URL } from '../../config.js';

const ModernNavbarPureCSS = ({ UserName, prefix, TabActiveId }) => {
  const [activeTab, setActiveTab] = useState(TabActiveId);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [userType, setUserType] = useState('');
  const dropdownRef = useRef(null);
  const [userBadge, setUserBadge] = useState('');
  const navigate = useNavigate();

  const [notifications] = useState({
    messages: 3,
    jobs: 2,
    reviews: 1
  });

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsProfileDropdownOpen(false);
    }
  };

  useEffect(() => {

    setActiveTab(TabActiveId);


    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mousedown', handleClickOutside);
    const image = sessionStorage.getItem('userImage');
    //console.log("Image from session storage:", image);
    if (image && image !== "null") {
      setProfileImage(image);
      //console.log("Profile image set:", image);
    }

    const token = localStorage.getItem('token');
    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            setUserEmail(decodedToken.email || '');

            const myUserType = decodedToken.UserType || '';
            setUserType(myUserType);


            const devName = localStorage.getItem('developerBusinessName');
            
            if (myUserType === 'Business') {
                setUserBadge('Professional');
            } else if (myUserType === 'Home' && devName) { // Check if it's a Home user AND has a dev name
                setUserBadge('Developer');
            } else {
                setUserBadge('Homeowner'); // Default for all other Home users
            }
            



        } catch (error) {
            console.error("Error decoding token:", error);
        }
    }

    return () => {
        window.removeEventListener('sroll', handleScroll);
        document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const navItemsHomeUser = [
    { id: 'home', label: 'Home', icon: Home, href: '/newhome', badge: null },
    { id: 'search', label: 'Search', icon: Search, href: '/map-search-v2', badge: null },
    { id: 'projects', label: 'Projects', icon: Briefcase, href: '/projects', badge: null },
    { id: 'messages', label: 'Messages', icon: MessageCircle, href: '/home_messages', badge: null },
    { id: 'reviews', label: 'Reviews', icon: Star, href: '/business-reviews', badge: null },
    { id: 'saved', label: 'Saved', icon: Heart, href: '/saved-businesses', badge: null },
    { id: 'social', label: 'Social', icon: User, href: `${SOCIAL_FRONTEND_URL}`, badge: null },

  ];

  const navItemsBusiness = [
    { id: 'home', label: 'Home', icon: Home, href: '/newbusiness', badge: null },
    { id: 'search', label: 'Search', icon: Search, href: '/map-search-v2', badge: null },
    { id: 'jobs', label: 'Jobs', icon: Briefcase, href: '/business-jobs-dashboard', badge: null },
    { id: 'messages', label: 'Messages', icon: MessageCircle, href: '/business_messages', badge: null },
    { id: 'reviews', label: 'Reviews', icon: Star, href: '/business-reviews', badge: null },
    { id: 'portfolios', label: 'Portfolio', icon: Star, href: '/business-portfolios', badge: null },
    { id: 'subscription', label: 'Subscription', icon: Gem, href: '/subscription/subscribenew', badge: null },
    { id: 'social', label: 'Social', icon: User, href: `${SOCIAL_FRONTEND_URL}`, badge: null },
  ];


  const handleAccountSettingsClick = () => {
    // Navigate to the new route you defined in App.js
    navigate('/account/change-password');
    setIsProfileDropdownOpen(false); // Close the dropdown after clicking
  };




  const handleNavClick = (item) => {
    //console.log(`clicked = ${item.id}`);
    //alert(`clicked = ${item.id}`);
    setActiveTab(item.id);
    setIsMobileMenuOpen(false);
    window.location.href = item.href;
  };

  const handleMyProfileClick = () => {

    const userType = jwtDecode(localStorage.getItem('token')).UserType;

    if (userType === 'Business') {
      const businessId = localStorage.getItem('loggedInBusinessId');
      window.location.href = `/business-onboarding-new/${businessId}`;
    } else {
      const loggedInHomeUserId = localStorage.getItem('loggedInHomeUserId');
      window.location.href = `/home-user-profile/${loggedInHomeUserId}`;
    }

  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('loginSuccessMessage');
    sessionStorage.removeItem('showToast');
    sessionStorage.removeItem('showBusinessToast');
    sessionStorage.removeItem('userImage');
    localStorage.removeItem('businesName');
    localStorage.removeItem('developerBusinessName');
    window.location.href = '/';
  };

  return (
    <>
      <nav className={`${styles.modern_navbar} ${isScrolled ? styles.modern_navbar_scrolled : ''}`}>
        <div className={styles.modern_navbar_container}>
          <div className={styles.modern_navbar_logo}>
            <div className={styles.logo_icon}>
                        <img
            src={imageLogo}   // Replace with your logo image path
            alt="Build Start Logo"
            style={{ height: '35px', marginRight: '10px' }}  // Adjust size & spacing as needed
          />
            </div>
            <div className={styles.logo_text}>


              <span className={styles.logo_brand}>BuildStart</span>


              {userBadge && (
                <span className={styles.logo_badge}>{userBadge}</span>
              )}


            </div>
          </div>

          <div className={styles.modern_navbar_nav}>
            {(userType === 'Business' ? navItemsBusiness : navItemsHomeUser).map((item) => {
              const IconComponent = item.icon;
              return (
                <button
                  key={item.id}
                  onClick={() => handleNavClick(item)}
                  className={`${styles.nav_item} ${activeTab === item.id ? styles.nav_item_active : ''}`}
                >
                  <div className={styles.nav_item_content}>
                    <div className={styles.nav_item_icon_wrapper}>
                      <IconComponent className={styles.nav_item_icon} />
                      {item.badge && (
                        <span className={styles.nav_item_badge}>
                          {item.badge}
                        </span>
                      )}
                    </div>
                    <span className={styles.nav_item_label}>{item.label}</span>
                  </div>
                  <div className={styles.nav_item_indicator}></div>
                </button>
              );
            })}
          </div>

          <div className={styles.modern_navbar_right}>
            <div className={styles.profile_dropdown_container} ref={dropdownRef}>
              <button
                onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
                className={styles.profile_button}
              >
                <img src={profileImage || "/placeholder.svg?height=40&width=40"} alt={UserName} className={styles.profile_avatar} />
                <div className={styles.profile_info}>
                  <span className={styles.profile_name}>{UserName}</span>


                  {userBadge && (
                    <span className={styles.profile_role}>{userBadge}</span>
                  )}



                </div>
                <ChevronDown className={`${styles.profile_chevron} ${isProfileDropdownOpen ? styles.profile_chevron_open : ''}`} />
              </button>

              {isProfileDropdownOpen && (
                <div className={styles.profile_dropdown_menu}>
                  <div className={styles.profile_dropdown_header}>
                    <img src={profileImage || "/placeholder.svg?height=48&width=48"} alt={UserName} style={{ width: '3rem', height: '3rem', borderRadius: '50%' }}/>
                    <div>
                      <div style={{ fontWeight: 600, color: '#111827' }}>{UserName}</div>
                      <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>{userEmail}</div>
                    </div>
                  </div>
                  <div className={styles.profile_dropdown_divider}></div>
                  <div className={styles.profile_dropdown_items}>
                    <button className={styles.profile_dropdown_item} onClick={handleMyProfileClick}>
                      <User style={{ width: '1rem', height: '1rem' }} />
                      <span>Edit Profile</span>
                    </button>

                    <button className={styles.profile_dropdown_item} onClick={handleAccountSettingsClick}>
                      <Settings style={{ width: '1rem', height: '1rem' }} />
                      <span>Account Settings</span>
                    </button>

                    <button className={styles.profile_dropdown_item}>
                      <HelpCircle style={{ width: '1rem', height: '1rem' }} />
                      <span>Help & Support</span>
                    </button>
                  </div>
                  <div className={styles.profile_dropdown_divider}></div>
                  <button className={`${styles.profile_dropdown_item} ${styles.profile_dropdown_logout}`} onClick={handleLogout}>
                    <LogOut style={{ width: '1rem', height: '1rem' }} />
                    <span>Sign Out</span>
                  </button>
                </div>
              )}
            </div>

            <button
              className={styles.mobile_menu_button}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X style={{ width: '1.5rem', height: '1.5rem' }} /> : <Menu style={{ width: '1.5rem', height: '1.5rem' }} />}
            </button>
          </div>

        </div>

        {isMobileMenuOpen && (
          <div className={styles.mobile_nav_overlay}>
            <div className={styles.mobile_nav_menu}>
              {(userType === 'Business' ? navItemsBusiness : navItemsHomeUser).map((item) => {
                const IconComponent = item.icon;
                return (
                  <button
                    key={item.id}
                    onClick={() => handleNavClick(item)}
                    className={`${styles.mobile_nav_item} ${activeTab === item.id ? styles.mobile_nav_item_active : ''}`}
                  >
                    <div className={styles.mobile_nav_item_icon_wrapper}>
                      <IconComponent style={{ width: '1.5rem', height: '1.5rem' }} />
                      {item.badge && (
                        <span className={styles.mobile_nav_badge}>
                          {item.badge}
                        </span>
                      )}
                    </div>
                    <span className={styles.mobile_nav_item_label}>{item.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </nav>

      {isMobileMenuOpen && (
        <div 
          className={styles.mobile_nav_backdrop}
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

export default ModernNavbarPureCSS;
